import { render } from "./MarkdownEmailEditor.vue?vue&type=template&id=28b35be0&scoped=true"
import script from "./MarkdownEmailEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEmailEditor.vue?vue&type=script&lang=js"

import "./MarkdownEmailEditor.vue?vue&type=style&index=0&id=28b35be0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b35be0"]])

export default __exports__